import {faTimes} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {exhaustive} from '@freckle/exhaustive'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {H3} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {PaywallNotificationTypeT} from '@freckle/classroom/ts/common/helpers/paywall-notification'
import {
  paywallNotification,
  paywallNotificationsJT,
  closeNotification,
} from './notification.module.scss'

function getPaywallMessage(t: TranslateT, type: PaywallNotificationTypeT) {
  switch (type) {
    case 'old-report':
      return <span>{t('PAYWALL_NOTIFICATION_OLD_REPORT_COPY')}</span>
    case 'print-without-answers':
      return <span>{t('PAYWALL_NOTIFICATION_PRINT_WIHOUT_ANSWERS_COPY')}</span>
    case 'multiple-assessments':
      return <span>{t('PAYWALL_NOTIFICATION_MULTIPLE_ASSESSMENTS_COPY')}</span>
    case 'max-courses':
      return <span>{t('PAYWALL_NOTIFICATION_MAX_COURSES_COPY')}</span>
    case 'assignment-scheduling':
      return <span>{t('PAYWALL_NOTIFICATION_ASSIGNMENT_SCHEDULING_COPY')}</span>
    case 'no-assignments-left-this-week':
      return <span>{t('PAYWALL_NOTIFICATION_NO_ASSIGNMENTSS_LEFT_COPY')}</span>

    default:
      return exhaustive(type, 'getPaywallMessage')
  }
}

type Props = {
  notificationType: PaywallNotificationTypeT
  removeNotification: () => void
  onCtaClicked: () => void
}

export default function PaywallNotification(props: Props) {
  const {notificationType, removeNotification, onCtaClicked} = props
  const {t} = useSafeTranslation()

  const paywallMessage = getPaywallMessage(t, notificationType)

  const button = (
    <Button onClick={onCtaClicked} style="primary" className="paywall-notifications-action">
      {t('PAYWALL_NOTIFICATION_CTA_BUTTON_TEXT')}
    </Button>
  )

  return (
    <div className={paywallNotification} data-test="paywall-notification">
      <Flex justifyContent="space-between">
        <H3>{t('PAYWALL_NOTIFICATION_HEADER_TITLE')}</H3>
        <span onClick={removeNotification}>
          <FontAwesomeIcon icon={faTimes} className={closeNotification} />
        </span>
      </Flex>

      <p className="paywall-message">{paywallMessage}</p>
      {button}

      <img
        className={paywallNotificationsJT}
        src={`${PATHS.imageAssetsUrl}/teacher-dashboard/winning-piggy.png?w=68&h=103`}
        alt=""
        title=""
      />
    </div>
  )
}
